export default __webpack_public_path__ + "static/media/Gauntlets of the Ostiary.ac95cb60.jpg";